module.exports = new __parcel__URL__("shop_machines_beer_machine.3e2cb98a.png").toString();